import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=35b260ec&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style1 from "./Home.vue?vue&type=style&index=1&id=35b260ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b260ec",
  null
  
)

export default component.exports